import { extractClosestEdge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge';

import { isCardDropTargetData, isColumnData } from '../../../../components/organisms/board/components/boardColumn/data';
import { contactsV2Api, itemsAdapter as contactsV2Adapter } from '../../../../services/contactsV2';

export const removeContactFromColumn = (args, contactId) =>
  contactsV2Api.util.updateQueryData('getContacts', args, (draft) => {
    contactsV2Adapter.removeOne(draft, contactId);

    if (draft.meta?.queryTotal > 0) {
      Object.assign(draft.meta, {
        queryTotal: draft.meta.queryTotal - 1,
      });
    }
  });

export const removeMultipleContactsFromColumn = (args, contactIds) =>
  contactsV2Api.util.updateQueryData('getContacts', args, (draft) => {
    if (!draft?.ids) return;

    const present = new Set(draft.ids);
    const actuallyRemoved = contactIds.filter((id) => present.has(id)).length;

    contactsV2Adapter.removeMany(draft, contactIds);

    if (draft.meta?.queryTotal > 0) {
      Object.assign(draft.meta, {
        queryTotal: Math.max(0, draft.meta.queryTotal - actuallyRemoved),
      });
    }
  });

export const getInsertColumnIndex = (destinationIds, dropTargetData) => {
  if (isCardDropTargetData(dropTargetData)) {
    const targetId = dropTargetData.card.contact.id;
    const idx = destinationIds.indexOf(targetId);

    if (idx === -1) {
      return destinationIds.length;
    }

    const edge = extractClosestEdge(dropTargetData);

    return edge === 'bottom' ? idx + 1 : idx;
  }
  if (isColumnData(dropTargetData)) {
    return destinationIds.length;
  }
  return destinationIds.length;
};

export const addContactToColumn = (args, contact, dropTargetData) =>
  contactsV2Api.util.updateQueryData('getContacts', args, (draft) => {
    contactsV2Adapter.upsertOne(draft, contact);
    const from = draft.ids.indexOf(contact.id);

    if (from !== -1) {
      draft.ids.splice(from, 1);
    }

    const insertIndex = getInsertColumnIndex(draft.ids, dropTargetData);

    draft.ids.splice(insertIndex, 0, contact.id);

    Object.assign(draft.meta, {
      queryTotal: draft.meta.queryTotal + 1,
    });
  });

export const addMultipleContactsToColumn = (args, contacts) =>
  contactsV2Api.util.updateQueryData('getContacts', args, (draft) => {
    contactsV2Adapter.upsertMany(draft, contacts);

    const existing = new Set(draft.ids);
    const idsToAdd = contacts.map((c) => c.id);

    // eslint-disable-next-line no-restricted-syntax
    for (const id of idsToAdd) {
      if (!existing.has(id)) {
        draft.ids.push(id);
        existing.add(id);
      }
    }

    Object.assign(draft.meta, {
      queryTotal: draft.meta.queryTotal + contacts.length,
    });
  });
